import React, { useMemo } from 'react'

import dayjs from 'dayjs'
import { FaClock, FaHouseUser } from 'react-icons/fa6'
import { PiHandsClappingFill } from 'react-icons/pi'
import { TbCameraShare } from 'react-icons/tb'

import { Section, SectionProgress } from '../../../..'
import { useUser } from '../../../../../context'
import { useDataByMonth } from '../../../../../hooks/useDataByMonth'
import { useRankingData } from '../../../../../hooks/useRankingData'
import { SectionObject } from '../../../../../types'
import { capitalizeFirstLetter } from '../../../../../utilFunctions/transformFunc'

const ProgressSection = () => {
  const date = capitalizeFirstLetter(dayjs().format('MMMM, YYYY'))
  const { user } = useUser()
  const { currentMonthLogins, currentMonthLogs } = useDataByMonth(user)
  const { points } = useRankingData(user)

  const progressData: SectionObject[] | null = useMemo(() => {
    if (!user || !user?.uid) return null
    return [
      {
        amount: currentMonthLogs,
        amountTitle: 'Clases Consecutivas',
        icon: FaClock,
      },
      {
        amount: currentMonthLogins,
        amountTitle: 'Entrenamiento en casa',
        icon: FaHouseUser,
      },
      {
        amount: 0,
        amountTitle: 'Desafios compartidos',
        icon: TbCameraShare,
      },
      {
        amount: points,
        amountTitle: 'Ah-\nplausos!',
        icon: PiHandsClappingFill, //'/assets/logo-sm.svg',
        hoverText: `Explicación del ranking`,
      },
    ]
  }, [currentMonthLogins, currentMonthLogs, user, points])

  return progressData ? (
    <Section
      title="Mi progreso"
      subtitle={date}
      childrenClass="progress-section"
      children={<SectionProgress sectionProgressData={progressData} />}
      // children2={
      //   <Percentage percentage={50} description="mas que el anterior" />
      // }
    />
  ) : null
}

export default ProgressSection
